import styles from "@/components/pages/home/home-page.module.scss";
import DefaultVoiceSelector from "@/components/common/voice-selector/selectors/default-voice-selector";
import React from "react";
import OurAppCard from "@/components/pages/our-apps/components/our-app-card";

const HomePage = () => {
  const services = [
    {
      title: "AI Stem Splitter",
      description:
        "Upload a full track. Split it into four stems: vocals, drums, bass, and instruments.",
      href: "/stem-splitter",
    },
    {
      title: "AI Vocal Remover",
      description:
        "Remove vocals from any song with Audiomodify's easy-to-use tool. Create karaoke tracks or isolate instrumental music effortlessly with our advanced vocal remover.",
      href: "/vocal-remover",
    },
    {
      title: "Key and BPM Finder",
      description:
        "Quickly find the key and BPM of your music with AudioModify's tool. Upload your audio file and get accurate musical details in seconds for better mixing.",
      href: "/key-bpm-finder",
    },
    {
      title: "AI Text To Speech",
      description:
        "Transform text into lifelike speech with AudioModify’ text to speech. AudioModify ultra-realistic text-to-speech supports different languages languages. Convert text to audio for free with our TTS today.",
      href: "/text-to-speech",
    },
    {
      title: "AI Mastering",
      description: "Mastering your song using AI in seconds with AudioModify",
      href: "/ai-mastering",
    },
  ];

  return (
    <div className={styles.main}>
      {/*<DefaultVoiceSelector />*/}
      <div className={styles.title}>AI AudioModify</div>
      <div className={styles.services}>
        {services.map((service) => (
          <OurAppCard key={service.href} app={service} />
        ))}
      </div>
    </div>
  );
};

export default HomePage;
